import { Button, Grid, Typography } from "@mui/material";
import "../AppMobileXS.css";
import ButtonCeci from "./ButtonCeci";

export default function Card2() {
    return (
        <Grid container size={12} sx={{width: '70%', marginLeft: '27%', marginTop: '14vh'}}>
            <Grid item  size={9} sx={{textAlign: 'left'}}>
                <div className="stile-titolo bianco">JASMINE <br/>PASQUA</div>
                <div style={{marginTop: '10px'}} className="stile-sottotitolo bianco">sono una chinesiologa laureata in scienze delle attività motorie e <br/>sportive e specializzata <br/>nella ginnastica <br/>posturale</div>
            </Grid>
        </Grid>
    );
}
